import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';

interface CampoComentario {
  key: string;
  value: string;
  isCustom: boolean;
}

@Component({
  selector: 'app-comentario-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './comentario-grupo-modal.html',
  styleUrls: ['./comentario-grupo-modal.css']
})
export class ComentarioModalComponent implements OnChanges {
  private readonly defaultKeys = ['DESCRICAO_GRUPO', 'QUANTIDADE_GRUPO', 'OBSERVACAO'];

  @Input() isOpen = false;
  @Input() title = 'Adicionar comentario';
  @Input() initialMap: Map<string, string> | Record<string, string> | null = null;

  @Output() cancelled = new EventEmitter<void>();
  @Output() saved = new EventEmitter<Map<string, string>>();

  campos: CampoComentario[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] && this.isOpen) {
      this.initializeCampos();
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: Event): void {
    if (!this.isOpen) {
      return;
    }

    event.preventDefault();
    this.onCancel();
  }

  onBackdropClick(): void {
    this.onCancel();
  }

  onCancel(): void {
    this.cancelled.emit();
  }

  addCampoCustom(): void {
    this.campos.push({ key: '', value: '', isCustom: true });
  }

  onSave(): void {
    const comentarioMap = new Map<string, string>();

    for (const defaultKey of this.defaultKeys) {
      const field = this.campos.find((item) => item.key === defaultKey && !item.isCustom);
      comentarioMap.set(defaultKey, field?.value?.trim() ?? '');
    }

    for (const campo of this.campos.filter((item) => item.isCustom)) {
      const key = campo.key.trim();
      if (!key) {
        continue;
      }
      comentarioMap.set(key, campo.value.trim());
    }

    this.saved.emit(comentarioMap);
  }

  private initializeCampos(): void {
    const sourceMap = this.toMap(this.initialMap);

    this.campos = this.defaultKeys.map((key) => ({
      key,
      value: sourceMap.get(key) ?? '',
      isCustom: false
    }));

    sourceMap.forEach((value, key) => {
      if (this.defaultKeys.includes(key)) {
        return;
      }

      this.campos.push({ key, value, isCustom: true });
    });
  }

  private toMap(value: Map<string, string> | Record<string, string> | null): Map<string, string> {
    if (!value) {
      return new Map<string, string>();
    }

    if (value instanceof Map) {
      return new Map<string, string>(value);
    }

    return new Map<string, string>(Object.entries(value));
  }
}